import React from 'react';

import { PARTNER_ACCOUNT } from '../../Pages';

export default {
  path: PARTNER_ACCOUNT.pageURL,
  async action() {
    const { default: AdminPartnerAccountList } =
      await import('./AdminPartnerAccountList');
    return <AdminPartnerAccountList key={'management'} />;
  },
};
